<div class="infoBox pdfHide">
  <div class="title">
    @if (currentStage() === 'data') {
      The hard part is done!
    } @else {
      See your buildings energy data within the hour
    }
  </div>
  <div class="sub-title">
    @if (currentStage() === 'data') {
      We'll now show you exactly where and when you're spending the most — and how to reduce it.
    } @else {
      Share your meter details. We'll show you exactly where and when you're spending the most — and how to reduce it.
    }
  </div>

  <div class="px-3">
    <div class="d-flex align-items-center stage" [class.currentStage]="currentStage() === 'shared'">
      <fa-icon class="icon" [class.green]="isCompleted('shared')" [class.futureStateIcon]="isFuture('shared')" [style.color]="currentStage() === 'shared' ? brandColour() : null" [icon]="['far', 'check-circle']"></fa-icon>
      <div class="ps-3 stateText" [class.green]="isCompleted('shared')" [class.futureStateText]="isFuture('shared')" [style.color]="currentStage() === 'shared' ? brandColour() : null">You've shared your MPANs or MPRNs with us.</div>
    </div>
    <div class="d-flex align-items-center stage" [class.currentStage]="currentStage() === 'added'">
      <fa-icon class="icon" [class.green]="isCompleted('added')" [class.futureStateIcon]="isFuture('added')" [style.color]="currentStage() === 'added' ? brandColour() : null" [icon]="['far', 'check-circle']"></fa-icon>
      <div class="ps-3 stateText" [class.green]="isCompleted('added')" [class.futureStateText]="isFuture('added')" [style.color]="currentStage() === 'added' ? brandColour() : null">Your buildings have been added to the system</div>
    </div>
    <div class="d-flex align-items-center stage" [class.currentStage]="currentStage() === 'authorise'">
      <fa-icon class="icon" [class.green]="isCompleted('authorise')" [class.futureStateIcon]="isFuture('authorise')" [style.color]="currentStage() === 'authorise' ? brandColour() : null" [icon]="['fas', 'pen-to-square']"></fa-icon>
      <div class="ps-3 stateText" [class.green]="isCompleted('authorise')" [class.futureStateText]="isFuture('authorise')" [style.color]="currentStage() === 'authorise' ? brandColour() : null">Fill in this authorisation form. Takes two minutes. </div>
    </div>
    <div class="d-flex align-items-center stage" [class.currentStage]="currentStage() === 'data'">
      <fa-icon class="icon" [class.green]="isCompleted('data')" [class.futureStateIcon]="isFuture('data')" [style.color]="currentStage() === 'data' ? brandColour() : null" [icon]="['fas', 'chart-simple']"></fa-icon>
      <div class="ps-3 stateText" [class.green]="isCompleted('data')" [class.futureStateText]="isFuture('data')" [style.color]="currentStage() === 'data' ? brandColour() : null">We'll pull up to 36 months of historical data for you right now! * </div>
    </div>
  </div>

  <div class="pt-1 additionalText grey">* Historic data availability is dependent on third-party providers as well as the meter type, move-in or consent dates. </div>
</div>
